import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const PRESUPUESTOS_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/presupuestos?page=${page}${search || ''}`).then(res => res.data);
    },
    getById: async (idPresupuesto) => {
        return API.get('/presupuestos/' + idPresupuesto).then(res => res.data);
    },
    getPDF: async (presupuestoId) => {
        return API.get('/presupuestos/generate_pdf/' + presupuestoId, {responseType: 'blob'}).then(res => res.data);
    },
    calculate: async (presupuestoId) => {
        return API.get('/presupuestos/calcular_total/' + presupuestoId).then(res => res.data);
    },
    enable: async (presupuestoId) => {
        return API.get('/presupuestos/' + presupuestoId + '/enable').then(res => res.data);
    },
    disable: async (presupuestoId) => {
        return API.get('/presupuestos/' + presupuestoId + '/disable').then(res => res.data);
    },
    duplicate: async (presupuestoId) => {
        return API.get('/presupuestos/' + presupuestoId + '/duplicate').then(res => res.data);
    },
    search: async(search) => {
        return await API.post('/presupuestos/buscar?search=' + search).then(res => res.data);
    },
    new: async (presupuesto) => {
        return API.post('/presupuestos', presupuesto).then(res => res.data);
    },
    changeEntity: async (presupuestoId, cliente) => {
        return API.post('/presupuestos/' + presupuestoId + '/cliente', cliente).then(res => res.data);
    },
    sendNotificationToResponsible: async (validacion) => {
        return API.post('/presupuestos/validate-notificacion', validacion).then(res => res.data);
    },
    sendNotificationToRecambista: async (presupuestoId, validacion) => {
        return API.post(`/presupuestos/${presupuestoId}/no-validate-notificacion`,validacion).then(res => res.data);
    },
    updatePreciosCompra: async (presupuesto) => {
        return API.post('/presupuestos/' + presupuesto.id + '/precios_compra', presupuesto).then(res => res.data);
    },
    update: async (presupuesto, id) => {
        return API.post('/presupuestos/' + id + '/update', presupuesto, headers).then(res => res.data);
    },
    updateServicioEnvio: async (servicio, id) => {
        return API.post('/presupuestos/' + id + '/servicios_envio', servicio).then(res => res.data);
    },
    validate: async (presupuesto, id) => {
        return API.post('/presupuestos/' + id + '/validate', presupuesto).then(res => res.data);
    },
    exists: async (presupuesto, id) => {
        return API.post('/presupuestos/' + id + '/validate', presupuesto).then(res => res.data);
    },
    exportByEntity: async (filters) => {
        return API.post('/presupuestos/export/clientes', filters, {responseType: 'blob'}).then(res => res.data);
    },
    updateShippingAddres: async (direccionId, id) => {
        let direccion = {};
        direccion.direccion_envio_id = direccionId;
        return API.put('/presupuestos/' + id, direccion).then(res => res.data);
    },
    updateObservacionComercial: async (data) => {
        return API.post('presupuestos/update-observaciones-comercial', data).then(res => res.data);
    }
}